<template>
    <ValidationObserver ref="applicationForm" v-slot="{ invalid, pristine }">
        <b-row>
            <b-col sm="12" md="6" lg="6">
                <ValidationProvider name="university_id"  rules="required" v-slot="{ valid,errors }">
                    <b-form-group :label="$t('university')">
                        <university-selectbox :public="true" v-model="form.university_id"
                                              :disabled="isBauStudent || user.payment_status==='E'"
                                              :validate-error="errors[0]"

                        />
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" md="6" lg="6">
                <ValidationProvider name="student_status" rules="required" v-slot="{valid, errors}">
                    <b-form-group :label="$t('student_status')">
                        <multi-selectbox v-model="form.student_status" :multiple="false" :disabled="isBauStudent || user.payment_status==='E'" :options="studentStatusOptions" :validate-error="errors[0]"></multi-selectbox>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" md="6" lg="6">
                <ValidationProvider name="faculty_name" rules="required" v-slot="{valid, errors}">
                    <b-form-group :label="$t('faculty_name')">
                        <b-form-input size="sm" :readonly="isBauStudent || user.payment_status==='E'"  :state="errors[0] ? false : (valid ? true : null)"
                                      v-model="form.faculty" class="rounded-lg"></b-form-input>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" md="6" lg="6">
                <ValidationProvider name="program_name" rules="required" v-slot="{valid, errors}">
                    <b-form-group :label="$t('program_name')">
                        <b-form-input size="sm"  :readonly="isBauStudent || user.payment_status==='E'"   :state="errors[0] ? false : (valid ? true : null)"
                                      v-model="form.program" class="rounded-lg"></b-form-input>
                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>

                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" md="6" lg="6">
                <ValidationProvider name="application_type"  rules="required" v-slot="{ valid,errors }">
                    <b-form-group :label="$t('application_type')">
                        <ParameterSelectbox v-model="form.application_type"  code="toles_application_types"  :disabled="user.payment_status==='E'" :public="true" :validate-error="errors[0]"/>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" md="6" lg="6">
                <ValidationProvider name="application_detail"  rules="required" v-slot="{ valid,errors }">
                    <b-form-group :label="$t('course_code_option')+ '/'+$t('exam_name')">
                        <ParameterSelectbox v-model="form.application_detail"  :disabled="user.payment_status==='E'" code="toles_application_details"  :public="true" :validate-error="errors[0]"/>

                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col sm="12" md="6" lg="6">
                <ValidationProvider name="amount" v-slot="{ valid,errors }">
                    <b-form-group :label="$t('amount')">
                        <div class="label-as-input">
                            {{currencyFormat(form.amount) }}
                        </div>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" class="d-flex gap-2">
                <ProcessingButton :label="$t('save')" v-if="user.payment_status==='H'" :processing="loading" :disabled="loading" @click="saveAndContinue"/>
                <ProcessingButton :label="$t('make_payment')" v-if="user.payment_status==='H' &&  user.application_type && user.application_detail"  :disabled="invalid" @click="openPaymentModal"/>
            </b-col>
            <b-col cols="12">
            </b-col>
        </b-row>
        <CommonModal ref="paymentModal" size="md" :onHideOnlyX="true" @bHideModalHeaderClose="clear">
            <template v-slot:CommonModalContent>
                <CreditCartPaymentForm :payment-html="paymentHtml" v-if="formProcess==='payment'" @payment-success="payment($event)" :amount="form.amount"/>
            </template>
        </CommonModal>
    </ValidationObserver>
</template>
<script>
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import TolesApplicationServices from "@/services/TolesApplicationServices";
import CreditCartPaymentForm from "@/components/elements/CreditCartPaymentForm.vue";

export default {
    name: "ApplicationForm",
    components: {ProcessingButton,CreditCartPaymentForm},
    data(){
        return {
            user:{},
            paymentStatus:null,
            formProcess:null,
            sessionTimeout: null,
            TIMEOUT_DURATION: 30* 60 * 1000,//20dk
            form :{
                amount:0,
                university_id:null,
                student_status:null,
                faculty:null,
                program:null,
                application_type:null,
                application_detail:null,
            },
            timer:null,
            loading:false,
            paymentHtml:null,
            studentStatusOptions:[
                {
                    text:this.$t('continue'),
                    value:"101"
                },
                {
                    text:this.$t('graduate'),
                    value:"102"
                }
            ]
        }
    },
    mounted() {
        if (!localStorage.getItem('sessionExpiryTime')) {
            this.setNewExpiryTime();
        }
        this.startSessionTimer();
    },
    beforeDestroy() {
        this.clearSessionTimer();
    },
    computed:{
        pin(){
            return localStorage.getItem('pin')?JSON.parse(localStorage.getItem('pin')):null
        },
        isBauStudent(){
            return [3817].includes(this.user.university_id)
        }
    },
    watch:{
        'form.university_id'(newValue,oldValue){
            if (newValue!==oldValue){
                this.checkForm()
            }
        },
        'form.application_type'(newValue,oldValue){
            if (newValue !==oldValue){
                this.checkForm()

            }
        },
        'form.student_status' (newValue,oldValue){
            if (newValue!==oldValue){
                this.checkForm()
            }
        },
    },
    created() {
        this.user= localStorage.getItem('toles_application_user')?JSON.parse(localStorage.getItem('toles_application_user')):null
        if (this.user){
            this.form={
                university_id:this.user.university_id,
                student_status:this.user.student_status,
                faculty:this.user.faculty,
                program:this.user.program,
                application_type:this.user.application_type,
                amount: this.user.amount??0,
                application_detail:this.user.application_detail,
            }
        }
    },
    methods:{
        setNewExpiryTime() {
            const expiryTime = Date.now() + this.TIMEOUT_DURATION;
            localStorage.setItem('sessionExpiryTime', expiryTime);
        },
        startSessionTimer() {
            this.clearSessionTimer();

            const expiryTime = parseInt(localStorage.getItem('sessionExpiryTime'));
            const remainingTime = expiryTime - Date.now();
            if (remainingTime <= 0) {
                return this.handleTimeout();
            }

            this.sessionTimeout = setTimeout(() => {
                this.handleTimeout();
            }, remainingTime);
        },
        clearSessionTimer() {
            if (this.sessionTimeout) {
                clearTimeout(this.sessionTimeout);
                this.sessionTimeout = null;
            }
        },
        handleTimeout() {
            localStorage.removeItem('sessionExpiryTime');
            this.$store.dispatch('TolesApplicationStore/logout');
            this.$router.push('/toles/application/login').catch(()=>{});
            this.$toast.warning(this.$t('your_session_has_expired'))
        },
        clear(){
            this.paymentHtml=''
            this.formProcess=null
            this.checkPaymentStatus()
            this.$refs.paymentModal.$refs.commonModal.hide()

        },
        async payment(cartInformation){
            try {
                const form ={
                    national_id: this.user.national_id,
                    pin: this.pin,
                    card_number: cartInformation.card_number,
                    expiry_year: cartInformation.expiry_year,
                    expiry_month: cartInformation.expiry_month,
                    cvv: cartInformation.cvv,
                    card_holder_name: cartInformation.card_holder_name,
                }
                const res =await TolesApplicationServices.payment(form)
                this.paymentHtml=res.data
                this.openPaymentModal()
            }catch (err){
                this.showErrors(err)
            }
        },
        async saveAndContinue(){
            this.validateForm = await this.$refs.applicationForm.validate()
            if (!this.validateForm) return
            try {
                this.loading=true
                this.form.pin=this.pin
                this.form.national_id=this.user.national_id
                const res = await TolesApplicationServices.updateApplication(this.form)
                this.user=res.data.data
                this.$store.dispatch('TolesApplicationStore/setTolesApplicationUser',res.data.data)
                this.$toast.success(this.$t('proccess_success'))
            }catch (err){
                this.showErrors(err,this.$refs.applicationForm)
            }finally {
                this.loading=false
            }
        },
        checkForm(){
            if (this.form.student_status && this.form.application_type && this.form.university_id){
                if (this.timer)clearTimeout(this.timer)
                this.timer=setTimeout(()=>{
                    this.calculateAmount()
                },500)

            }
        },
        async calculateAmount(){
            if (this.user.payment_status==='E' && this.user.amount){
                this.form.amount=Number(this.user.amount)
                return
            }
            this.loading=true
            const formData ={
                application_type:this.form.application_type,
                university_id:this.form.university_id,
                student_status:this.form.student_status
            }
            try {
                const res =await TolesApplicationServices.calculateAmount(formData)
                const amount =res.data.data
                this.form.amount=amount ? Number(amount):0
            }catch (err){
                this.showErrors(err)
            }finally {
                this.loading=false
            }
        },
        openPaymentModal(){
            this.formProcess='payment'
            this.$refs.paymentModal.$refs.commonModal.show()
        },
        async checkPaymentStatus(){
             try {
                 const form = {
                     national_id:this.user.national_id,
                     pin:this.pin
                 }
                 const res =await TolesApplicationServices.login(form)
                 const data =res.data.data

                 if (data.payment_status==='E'){
                     this.user= {
                         university_id: data.university_id,
                         student_status: data.student_status,
                         faculty: data.faculty,
                         program: data.program,
                         application_type: data.application_type,
                         amount: data.amount ?? 0,
                         application_detail: data.application_detail,
                         payment_status: data.payment_status
                     }
                     this.$store.dispatch('TolesApplicationStore/setTolesApplicationUser',data)
                     this.$emit('successPayment',true)
                 }


             }catch (err){
                 this.showErrors(err)
             }
        }
    }
}
</script>

<style scoped>

.form-control:disabled, .form-control[readonly] {
    background-color: #ffffff;
    pointer-events: none;
    opacity: 0.6;

}

</style>
